import React, { useState, createContext, useContext } from 'react';
interface AgentContextType {
  activeAgentId: string;
  setActiveAgentId: (id: string) => void;
  selectedServiceId: string | null;
  setSelectedServiceId: (id: string | null) => void;
}
const AgentContext = createContext<AgentContextType | undefined>(undefined);
export function AgentProvider({
  children
}: {
  children: ReactNode;
}) {
  const [activeAgentId, setActiveAgentId] = useState<string>('1');
  const [selectedServiceId, setSelectedServiceId] = useState<string | null>(null);
  return <AgentContext.Provider value={{
    activeAgentId,
    setActiveAgentId,
    selectedServiceId,
    setSelectedServiceId
  }} data-id="element-1207">
      {children}
    </AgentContext.Provider>;
}
export function useAgent() {
  const context = useContext(AgentContext);
  if (context === undefined) {
    throw new Error('useAgent must be used within an AgentProvider');
  }
  return context;
}
export { AgentContext };